import { render, staticRenderFns } from "./AgriiProtectors.vue?vue&type=template&id=4a8527fe"
import script from "./AgriiProtectors.vue?vue&type=script&lang=js"
export * from "./AgriiProtectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports